<template>
	<DaModalFrame v-if="isUploadTimeTableGroupClass" v-model:open="modalIsOpen">
		<ChooseGroupClass
			@close="modalIsOpen = false"
			@submit="updateTimeTableGroupClass"
		/>
	</DaModalFrame>
	<DaModalFrame v-else v-model:open="modalIsOpen">
		<ChooseTargetUploading
			@close="modalIsOpen = false"
			@submit="uploadTimeTable"
		/>
	</DaModalFrame>
	<DaModalFrame v-model:open="daycareTargetOpen">
		<ChooseTargetUploading
			all-label="Cả lớp"
			@close="daycareTargetOpen = false"
			@submit="chooseDaycareTarget"
		/>
	</DaModalFrame>
	<DaModalFrame v-model:open="daycareCalendarOpen">
		<UpdateCalenderDaycare
			v-if="daycareClassSelected"
			:boarding="daycareClassSelected"
			@close="daycareCalendarOpen = false"
			@updated="onDaycareCalendarUpdated"
		/>
	</DaModalFrame>
	<div :class="daycareClassOpen ? 'side-over--active' : ''">
		<div
			v-if="daycareClassOpen"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="daycareClassOpen = false"
		></div>
		<ChooseDaycareClass
			:open="daycareClassOpen"
			@close="daycareClassOpen = false"
			@submit="continueDaycareClass"
		/>
	</div>
	<div :class="daycareStudentOpen ? 'side-over--active' : ''">
		<div
			v-if="daycareStudentOpen"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="daycareStudentOpen = false"
		></div>
		<ChooseDaycareStudent
			:open="daycareStudentOpen"
			:students="students"
			@close="daycareStudentOpen = false"
			@submit="continueDaycareStudent"
		/>
	</div>
	<div :class="isShow && !isUploadingForStudent ? 'side-over--active' : ''">
		<div
			v-if="isShow && !isUploadingForStudent"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="isShow = false"
		></div>
		<StatisticalTimeTable id="" @close="isShow = false" />
	</div>
	<div :class="isShow && isUploadingForStudent ? 'side-over--active' : ''">
		<div
			v-if="isShow && isUploadingForStudent"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="isShow = false"
		></div>
		<UploadTimeTableStudent
			id=""
			:student="studentSelected"
			:is-show="isShow && isUploadingForStudent"
			@close="isShow = false"
			:students="students"
		/>
	</div>
	<div :class="isShowUpload ? 'side-over--active' : ''">
		<div
			v-if="isShowUpload"
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="isShowUpload = false"
		></div>
		<UploadTimeTable
			:is-edit="false"
			:is-show="isShowUpload"
			@close="isShowUpload = false"
			@success="success"
		/>
	</div>
	<div class="__record px-10 pb-30 md-down:px-4">
		<div
			class="__record__header py-10 flex flex-nowrap justify-between items-center md-down:flex-col md-down:items-start gap-10 md-down:gap-4"
		>
			<div class="flex flex-nowrap items-center w-full justify-between">
				<div
					class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer"
				>
					<img
						v-if="activatedDate && !isOverview"
						src="@/assets/images/icons/arrow-right.png"
						alt=""
						class="w-4 h-4 cursor-pointer mr-3"
						style="transform: rotate(180deg)"
						@click="goToCurrentTimeTable"
					/>
					<DaIcon v-else class="mr-3 h-6 w-6" name="das--calender" />
					<span v-if="isOverview">Thời khoá biểu</span>
					<span v-else>{{
						activatedDate
							? 'Áp dụng từ ' +
							  $filters.formatDate2(activatedDate) +
							  (deactivatedDate
									? ' - ' +
									  $filters.formatDate2(deactivatedDate)
									: '')
							: scheduleTitle
					}}</span>
				</div>
				<button
					v-if="!isOverview"
					type="button"
					class="timetable-edit timetable-edit--mobile ml-3"
					:class="{ 'timetable-edit--compact': isUploadTimeTableGroupClass }"
					@click="editCurrentTimetable"
				>
					Chỉnh sửa
				</button>
				<Menu
					v-if="isOverview"
					as="div"
					class="ml-3 relative md:hidden"
				>
					<div>
						<MenuButton
							class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
						>
							<span class="sr-only">Open user menu</span>
							<svg
								fill="none"
								height="20"
								viewBox="0 0 20 20"
								width="20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									clip-rule="evenodd"
									d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
									fill="#94A3B8"
									fill-rule="evenodd"
								/>
							</svg>
						</MenuButton>
					</div>
					<transition
						enter-active-class="transition ease-out duration-200"
						enter-from-class="transform opacity-0 scale-95"
						enter-to-class="transform opacity-100 scale-100"
						leave-active-class="transition ease-in duration-75"
						leave-from-class="transform opacity-100 scale-100"
						leave-to-class="transform opacity-0 scale-95"
					>
						<MenuItems
							class="origin-top-right absolute right-0 mt-2 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
							:class="isOverview ? 'w-72' : 'w-60'"
						>
							<MenuItem
								v-if="isOverview"
								v-slot="{ active }"
								@click="editPersonalTimetable"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<DaIcon
										class="h-4 w-4 text-neutral-400"
										name="das--pen"
									/>
									<span class="mt-0.5"
										>Chỉnh sửa TKB cá nhân</span
									>
								</div>
							</MenuItem>
							<MenuItem
								v-if="isOverview"
								v-slot="{ active }"
								@click="editDaycareTimetable"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<DaIcon
										class="h-4 w-4 text-neutral-400"
										name="das--pen"
									/>
									<span class="mt-0.5"
										>Chỉnh sửa TKB bán trú</span
									>
								</div>
							</MenuItem>
							<MenuItem
								v-if="isOverview"
								v-slot="{ active }"
								@click="editGroupTimetable"
							>
								<div
									:class="active ? '' : ''"
									class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
								>
									<DaIcon
										class="h-4 w-4 text-neutral-400"
										name="das--pen"
									/>
									<span class="mt-0.5"
										>Chỉnh sửa TKB nhóm</span
									>
								</div>
							</MenuItem>
						</MenuItems>
					</transition>
				</Menu>
			</div>
			<div
				v-if="!is_old_data"
				class="flex flex-nowrap items-center"
			>
				<div v-if="activatedDate">
					<button
						class="button-p text-center shadow-none flex items-center justify-center w-fit px-4 bg-none btn--ghost"
						@click="goToCurrentTimeTable"
					>
						TKB hiện tại
					</button>
				</div>
				<div v-else class="__record__intro">
					<div
						class="search-input w-ful relative"
						style="width: 350px"
					>
						<div
							v-if="
								$route.name ===
								_ROUTER_NAME.SCHEDULE_TIMETABLE_GROUP_CLASSES
							"
							class="search-input w-92"
						>
							<div class="input-group input--xl">
								<input
									v-model="searchQuery"
									class="bg-white input-with-icon"
									placeholder="Tìm theo lớp nhóm"
									type="text"
									@keyup="searching"
									@keypress.enter="search"
								/>
								<div class="input-icon absolute top-1/2">
									<DaIcon
										class="h-4 w-4 text-neutral-400"
										name="das--search"
									/>
								</div>
							</div>
						</div>
						<div v-else class="bg-white select-tabs w-full">
							<Multiselect
								v-model="studentSelected"
								:options="
									students?.map((s) => {
										return {
											nameSearch: toEnglish(s?.name),
											...s,
										};
									})
								"
								:searchable="true"
								deselect-label="Bỏ chọn"
								label="nameSearch"
								placeholder="Tìm kiếm theo học sinh"
								selectLabel=""
								track-by="id"
								@open="!students.length && loadStudents()"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										{{ props.option.name }}
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="flex flex-nowrap items-center font-medium"
									>
										{{ option.name }}
									</div>
								</template>
							</Multiselect>
						</div>
					</div>
				</div>
				<button
					v-if="!isOverview"
					type="button"
					class="timetable-edit timetable-edit--desktop ml-3 flex-shrink-0"
					:class="{ 'timetable-edit--compact': isUploadTimeTableGroupClass }"
					@click="editCurrentTimetable"
				>
					Chỉnh sửa
				</button>
				<Menu
					v-if="isOverview"
					as="div"
					class="ml-3 relative md-down:hidden flex-shrink-0"
				>
						<div>
							<MenuButton
								class="rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
							>
								<span class="sr-only">Open user menu</span>
								<svg
									fill="none"
									height="20"
									viewBox="0 0 20 20"
									width="20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										clip-rule="evenodd"
										d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
										fill="#94A3B8"
										fill-rule="evenodd"
									/>
								</svg>
							</MenuButton>
						</div>
						<transition
							enter-active-class="transition ease-out duration-200"
							enter-from-class="transform opacity-0 scale-95"
							enter-to-class="transform opacity-100 scale-100"
							leave-active-class="transition ease-in duration-75"
							leave-from-class="transform opacity-100 scale-100"
							leave-to-class="transform opacity-0 scale-95"
						>
							<MenuItems
								class="origin-top-right absolute right-0 mt-2 rounded-md py-1 bg-white focus:outline-none z-10 shadow-sm border border-yellow-100"
								:class="isOverview ? 'w-72' : 'w-60'"
							>
								<MenuItem
									v-if="isOverview"
									v-slot="{ active }"
									@click="editPersonalTimetable"
								>
									<div
										:class="active ? '' : ''"
										class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
									>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--pen"
										/>
										<span class="mt-0.5"
											>Chỉnh sửa TKB cá nhân</span
										>
									</div>
								</MenuItem>
								<MenuItem
									v-if="isOverview"
									v-slot="{ active }"
									@click="editDaycareTimetable"
								>
									<div
										:class="active ? '' : ''"
										class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
									>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--pen"
										/>
										<span class="mt-0.5"
											>Chỉnh sửa TKB bán trú</span
										>
									</div>
								</MenuItem>
								<MenuItem
									v-if="isOverview"
									v-slot="{ active }"
									@click="editGroupTimetable"
								>
									<div
										:class="active ? '' : ''"
										class="p-2 px-4 bg-white z-10 text-gray-600 hover:bg-neutral-50 flex items-center gap-4 cursor-pointer"
									>
										<DaIcon
											class="h-4 w-4 text-neutral-400"
											name="das--pen"
										/>
										<span class="mt-0.5"
											>Chỉnh sửa TKB nhóm</span
										>
									</div>
								</MenuItem>
							</MenuItems>
						</transition>
				</Menu>
			</div>
		</div>
		<ScheduleSectionNav v-if="!isOverview" />
		<div class="mb-10" v-if="alertShow && !isOverview">
			<div
				class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
			>
				<div class="flex justify-between gap-4">
					<div class="flex items-center gap-4">
						<div>
							<img
								src="@/assets/images/logo/logo.svg"
								alt="luca-logo"
								height="24"
								width="35"
							/>
						</div>
						<div class="pt-1 text-neutral-600 text-sm">
							Bạn đã thiết lập Thời khoá biểu nhưng chưa bật tính
							năng lịch học. Bật để quản lý lịch học và dạy theo
							thời khóa biểu, cùng với các chức năng quản lý
							chuyên cần như báo nghỉ, đổi
							{{ $filters.terminology('teacher') }}, tạo buổi học
							phát sinh, v.v. Các báo cáo cũng sẽ được tạo tự động
							theo Thời khóa biểu.
							<span
								@click="$router.push('/setup-center/schedule')"
								class="underline text-green-500 font-medium cursor-pointer"
								target="_blank"
								rel="noopener"
								>Bật tính năng lịch học?</span
							>
						</div>
					</div>
					<div>
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							class="cursor-pointer"
							@click="alertShow = false"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
								fill="#E5A42B"
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!activatedDate && applyRange !== null" class="mb-10">
			<div class="text-neutral-600 font-semibold text-2xl">
				<span v-if="is_current_applied">TKB hiện tại · </span>Áp dụng từ
				{{ $filters.formatDate(applyRange.start_date) }}
				<span v-if="applyRange.end_date"
					>đến {{ $filters.formatDate(applyRange.end_date) }}</span
				>
			</div>
		</div>
		<div class="__record__content">
			<!-- <div class="w-full mb-10">
				<div class="border-b border-neutral-200 md-down:hidden">
					<nav aria-label="Tabs" class="-mb-px flex space-x-8 tabs">
						<router-link
							v-for="tab in tabs"
							:key="tab.id"
							:to="{
								name: tab.link,
							}"
							class="
								border-transparent
								hover:text-yellow-700 hover:border-yellow-500
								text-neutral-500
								whitespace-nowrap
								py-3
								px-1
								border-b-2
								font-semibold
								cursor-pointer
							"
						>
							<div class="flex items-center gap-2">
								<div>
									<DaIcon :name="tab.icon" class="h-4 w-4" />
								</div>
								<div>{{ tab.name }}</div>
							</div>
						</router-link>
					</nav>
				</div>
			</div> -->
			<div>
				<router-view
					v-model:isShow="isShow"
					v-model:isShowUpload="isShowUpload"
					v-model:isUploadingForStudent="isUploadingForStudent"
					v-model:modalIsOpen="modalIsOpen"
					v-model:studentSelected="studentSelected"
					:onRefetch="onRefetch"
					@updateTimeTable="updateTimeTable"
					@applyRange="applyRangeFunction"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { $api } from '@/services';
import dayjs from 'dayjs';
import Multiselect from '@suadelabs/vue3-multiselect';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { toEnglish } from '@/helper/toEnglish';
import { _ROUTER_NAME } from '@/enums';
import UploadTimeTableStudent from '@/views/timetable/features/UploadTimeTableStudent.vue';
import ChooseTargetUploading from '@/views/timetable/features/ChooseTargetUploading.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import UploadTimeTable from '@/views/timetable/features/UploadTimeTable.vue';
import StatisticalTimeTable from '@/views/timetable/features/StatisticalTimeTable.vue';
import ChooseGroupClass from '@/views/timetable/features/ChooseGroupClass.vue';
import ChooseDaycareClass from '@/views/timetable/features/ChooseDaycareClass.vue';
import ChooseDaycareStudent from '@/views/timetable/features/ChooseDaycareStudent.vue';
import UpdateCalenderDaycare from '@/views/daycareClass/features/UpdateCalenderDaycare.vue';
import ScheduleSectionNav from '@/components/modules/schedule/ScheduleSectionNav.vue';
import {
	scheduleKindFromRoute,
	scheduleSectionTitle,
} from '@/helper/scheduleSection';

export default defineComponent({
	name: 'TimeTableGroupClass',
	components: {
		ChooseGroupClass,
		ChooseDaycareClass,
		ChooseDaycareStudent,
		UpdateCalenderDaycare,
		DaIcon,
		Multiselect,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
		UploadTimeTableStudent,
		ChooseTargetUploading,
		DaModalFrame,
		UploadTimeTable,
		StatisticalTimeTable,
		ScheduleSectionNav,
	},
	data() {
		return {
			students: [],
			params: {
				date: dayjs().format('YYYY-MM-DD'),
			},
			studentSelected: {},
			modalIsOpen: false,
			isShowUpload: false,
			isShow: false,
			isUploadingForStudent: false,
			onRefetch: 0,
			searchQuery: '',
			alertShow: false,
			daycareTargetOpen: false,
			daycareClassOpen: false,
			daycareStudentOpen: false,
			daycareCalendarOpen: false,
			daycareClassSelected: null,
			applyRange: null,
			is_current_applied: false,
		};
	},

	mounted() {
		if (this.studentId) this.fetchStudents();
		if (this.$route.hash) this.isShowUpload = true;

		if (this.$route.query.hasModal === 'true') {
			this.updateTimeTable();
		}
		if (this.enablePersonalSchedule) this.alertShow = true;
	},

	watch: {
		'$route.name': {
			immediate: true,
			handler(value) {
				if (value === _ROUTER_NAME.SCHEDULE_TIMETABLE_CLASS) {
					this.searchQuery = undefined;
					if (this.$route.query?.query) {
						this.$router.replace({
							query: {
								...this.$route.query,
								query: undefined,
							},
						});
					}
				}
			},
		},

		'$route.query.query': {
			immediate: true,
			handler(value) {
				this.searchQuery = value || undefined;
			},
		},

		'$route.query.hasModal'(value) {
			if (value === 'true') this.updateTimeTable();
		},

		isChoosingStudent(value) {
			if (value) this.loadStudents();
		},
	},

	computed: {
		_ROUTER_NAME() {
			return _ROUTER_NAME;
		},

		scheduleTitle() {
			return scheduleSectionTitle(this.$route);
		},

		isOverview() {
			return this.$route.name === _ROUTER_NAME.FACILITY_TIMETABLE;
		},

		isDaycareTimetable() {
			return scheduleKindFromRoute(this.$route) === 'daycare';
		},

		isChoosingStudent() {
			return (
				this.daycareStudentOpen ||
				(this.isShow && this.isUploadingForStudent)
			);
		},

		isUploadTimeTableGroupClass() {
			return (
				this.$route.name ===
				_ROUTER_NAME.SCHEDULE_TIMETABLE_GROUP_CLASSES
			);
		},

		tabs() {
			return [
				{
					id: 0,
					name: 'Học cá nhân',
					icon: 'das--book',
					link: _ROUTER_NAME.SCHEDULE_TIMETABLE_CLASS,
				},
				{
					id: 1,
					name: 'Học nhóm',
					icon: 'das--users',
					link: _ROUTER_NAME.SCHEDULE_TIMETABLE_GROUP_CLASSES,
				},
			];
		},

		studentId() {
			return this.$route.query.student;
		},

		oldPayload() {
			return {
				'x-cross': this.$route.query.org_id,
			};
		},

		is_old_data() {
			return this.$route.query.is_old_data === 'true';
		},
		enablePersonalSchedule() {
			return (
				this.$store.state.profile.has_timetable &&
				!this.$store.state.profile.current_org.enable_personal_schedule
			);
		},
		deactivatedDate() {
			return this.$route.query.deactivated_date;
		},
		activatedDate() {
			return this.$route.query.activated_date;
		},
	},

	methods: {
		toEnglish,

		applyRangeFunction(range, isCurrentApplied) {
			this.applyRange = range;
			this.is_current_applied = !!isCurrentApplied;
		},

		searching() {
			clearInterval(this.typing);
			this.typing = setTimeout(() => {
				this.search();
			}, 1000);
		},

		search() {
			this.$router.push({
				query: {
					...this.$route.query,
					query: this.searchQuery,
				},
			});
		},

		async fetchStudents() {
			const loaded = await this.loadStudents();
			if (loaded && this.studentId) {
				this.studentSelected = this.students.find(
					(item) => Number(item.id) === Number(this.studentId)
				);
			}
		},

		async loadStudents() {
			const isTeacher =
				this.$store.state.profile.staff.role === 'teacher';
			// ChooseDaycareStudent shows the selected student's avatar
			const params = { include_profile_photo: true };
			try {
				let res;
				if (this.is_old_data) {
					res = await $api.student.getStudents(
						isTeacher ? 'staff' : 'org_admin',
						{},
						this.oldPayload
					);
				} else if (isTeacher) {
					res = await $api.student.getSimpleStudents(params);
				} else {
					res = await $api.student.getOrgSimpleStudents(params);
				}
				this.students = res?.data?.data || [];
				return true;
			} catch (e) {
				console.log(e);
				return false;
			}
		},

		updateTimeTable() {
			if (Object.keys(this.studentSelected).length > 0) {
				this.isUploadingForStudent = true;
				this.modalIsOpen = false;
				this.isShow = true;
			} else {
				this.modalIsOpen = true;
			}
			this.$router.push({
				query: {
					...this.$route.query,
					hasModal: undefined,
				},
			});
		},

		uploadTimeTable(value) {
			this.modalIsOpen = false;
			this.isUploadingForStudent = !value;
			if (value) {
				this.isShowUpload = true;
			} else {
				this.isShow = true;
			}
		},

		success() {
			this.isShowUpload = false;
			this.onRefetch++;
		},

		updateTimeTableGroupClass(id) {
			this.$router.push(`/group-classes/${id}`);
		},

		editPersonalTimetable() {
			this.studentSelected = {};
			this.$router.push({
				name: _ROUTER_NAME.SCHEDULE_TIMETABLE_CLASS,
				query: { hasModal: 'true' },
			});
		},

		editCurrentTimetable() {
			if (this.isDaycareTimetable) {
				this.openDaycareEdit();
				return;
			}
			this.updateTimeTable();
		},

		editDaycareTimetable() {
			this.studentSelected = {};
			this.$router.push({
				name: _ROUTER_NAME.SCHEDULE_TIMETABLE_CLASS,
				query: { type: 'daycare' },
			});
		},

		openDaycareEdit() {
			this.modalIsOpen = false;
			this.isShow = false;
			this.isShowUpload = false;
			this.daycareClassOpen = false;
			this.daycareStudentOpen = false;
			this.daycareCalendarOpen = false;
			this.daycareTargetOpen = true;
		},

		chooseDaycareTarget(isClass) {
			this.daycareTargetOpen = false;
			this.daycareClassOpen = !!isClass;
			this.daycareStudentOpen = !isClass;
		},

		continueDaycareClass(klass) {
			this.daycareClassSelected = {
				...klass,
				days_of_week: klass.class_day_slots || klass.days_of_week || [],
			};
			this.daycareClassOpen = false;
			this.daycareCalendarOpen = true;
		},

		continueDaycareStudent(student) {
			this.daycareStudentOpen = false;
			this.$router.push(`/timetable-student/${student.id}?tab=daycare`);
		},

		onDaycareCalendarUpdated() {
			this.daycareCalendarOpen = false;
			this.daycareClassSelected = null;
			this.onRefetch++;
		},

		editGroupTimetable() {
			this.studentSelected = {};
			this.$router.push({
				name: _ROUTER_NAME.SCHEDULE_TIMETABLE_GROUP_CLASSES,
				query: { hasModal: 'true' },
			});
		},

		async goToCurrentTimeTable() {
			const query = { ...this.$route.query };
			delete query.activated_date;
			delete query.deactivated_date;
			await this.$router.push({ query });

			const hadStudentFilter = !!this.studentSelected?.id;
			this.searchQuery = undefined;
			this.studentSelected = {};

			if (!hadStudentFilter) this.onRefetch++;
		},
	},
});
</script>
<style lang="scss">
#timetable__table {
	scroll-behavior: smooth;
}

.tabs {
	.router-link-exact-active {
		@apply text-yellow-700 border-yellow-500;
	}
}

.timetable-edit {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	width: fit-content;
	height: 43px;
	padding: 0 20px;
	border: 1px solid #d89210;
	border-radius: 4px;
	background: transparent;
	color: #d89210;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	white-space: nowrap;
}

.timetable-edit--desktop {
	display: none;
}

.timetable-edit--compact {
	height: 41px;
}

@media (min-width: 768px) {
	.timetable-edit--mobile {
		display: none;
	}

	.timetable-edit--desktop {
		display: inline-flex;
	}
}
</style>
